import { LoadableLazy } from '@confluence/loadable';

export const LazyEditorContextCustomSitesConfigPanel = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorContextCustomSitesConfigPanel" */ './ConfigPanel/EditorContextCustomSitesConfigPanel'
			)
		).EditorContextCustomSitesConfigPanel,
});
